import { render } from "./modal.vue?vue&type=template&id=6585d566"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/components/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6585d566"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6585d566', __exports__)) {
    console.log('reload')
    api.reload('6585d566', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=6585d566", () => {
    console.log('re-render')
    api.rerender('6585d566', render)
  })

}


export default __exports__